//NOTE: styling can be manipulated from App.scss

function Heading_Default(props) {
    return <h3>{props.content}</h3>
}

export default Heading_Default;